import React from "react";
import {useSelector} from "react-redux";
import uoLogo from "../../assets/uo_logo.png";
import uoLogoPreview from "../../assets/uo_logo_ng.png";
import {useDispatch} from "react-redux";

import {BrowserRouter as Router, Switch, Route, Link, NavLink, useLocation} from "react-router-dom";
import Gravatar from "../../libs/Gravatar";
import SyncComponent from "../Sync/SyncComponent";
import stylelist from "stylelist";
import SharkIf from "../Util/IfCondition";
import {enable_sync, set_sync_status} from "../../actions/Sync";

import {Toaster} from "react-hot-toast";
import {disable_beta, enable_beta} from "../../actions/User";
import QuickAddModal from "../QuickAdd/QuickAddModal";
import PendingBillingIndicator from "./PendingBillingIndicator";
// import CommandPaletteModal from "../CommandPalette/CommandPaletteModal";  // Temporär deaktiviert
import "./Menu.scss";

const Menu = (props) => {
    // Get UserSettings from State
    const UserSettings = useSelector((state) => state.User);
    const SyncInfo = useSelector((state) => state.Sync);
    const CurrentUser = useSelector((state) => state.CurrentUser);
    const dispatch = useDispatch();
    const location = useLocation();

    const [zeiterfassungOpen, setZeiterfassungOpen] = React.useState(false);
    const [verwaltungOpen, setVerwaltungOpen] = React.useState(false);
    const [menuEffectsVisible, setMenuEffectsVisible] = React.useState(false);
    const [quickAddOpen, setQuickAddOpen] = React.useState(false);  // QuickAdd statt CommandPalette
    const isCustomApiUrl = !!localStorage.getItem('customApiUrl');

    const isZeiterfassungActive = ['/calendar', '/expenses'].includes(location.pathname);
    const isVerwaltungActive = ['/team', '/weclapp/customers', '/invoices', '/external-costs', '/administration'].includes(location.pathname);

    // Fade in menu effects after login
    React.useEffect(() => {
        if (CurrentUser.data) {
            setTimeout(() => setMenuEffectsVisible(true), 100);
        } else {
            setMenuEffectsVisible(false);
        }
    }, [CurrentUser.data]);

    // Scroll to top on route change
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    // Global keyboard shortcut for QuickAdd (Strg+K / Cmd+K)
    React.useEffect(() => {
        const handleKeyDown = (e) => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
                e.preventDefault();
                setQuickAddOpen(true);
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, []);

    const toggleBeta = (e) => {
        if (e.target.checked) {
            dispatch(enable_beta());
        } else {
            dispatch(disable_beta());
        }
    }

    return (
        <>
            <div className={`container-fluid menu-container ${menuEffectsVisible ? 'menu-container--effects-visible' : ''}`}>
                <nav className="navbar navbar-expand-lg navbar-light menu-navbar">
                    <Link className={`navbar-brand me-5 ${menuEffectsVisible ? 'menu-fade-in' : ''}`} to="/">

                        {UserSettings.betaEnabled &&
                            <>
                                <img src={uoLogoPreview} className="logo"/>
                            </>
                        }

                        {!UserSettings.betaEnabled &&
                            <>
                                <img src={uoLogo} className="logo"/>
                            </>
                        }
                    </Link>

                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className={`collapse navbar-collapse pl-5 ${menuEffectsVisible ? 'menu-fade-in' : ''}`} id="navbarSupportedContent">

                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">

                            {SyncInfo.loginStatus == "loggedIn" &&
                                <>
                                    <li className="nav-item me-4">
                                        <NavLink
                                            to="/dashboard"
                                            className="nav-link text-primary fw-semibold"
                                            activeClassName="nav-link-active"
                                        >Dashboard</NavLink>
                                    </li>

                                    <li className="nav-item dropdown me-4" onMouseEnter={() => setZeiterfassungOpen(true)} onMouseLeave={() => setZeiterfassungOpen(false)}>
                                        <a
                                            className={`nav-link dropdown-toggle text-primary cursor-pointer ${isZeiterfassungActive ? 'nav-link-active' : ''}`}
                                            onClick={() => setZeiterfassungOpen(!zeiterfassungOpen)}
                                        >
                                            Zeiterfassung
                                        </a>
                                        <ul className={`dropdown-menu dropdown-menu-glass ${zeiterfassungOpen ? 'show' : ''}`}>
                                            <li><Link to="/calendar" className="dropdown-item">Kalender</Link></li>
                                            <li><Link to="/expenses" className="dropdown-item">Aufwände</Link></li>
                                        </ul>
                                    </li>

                                    <li className="nav-item dropdown me-4" onMouseEnter={() => setVerwaltungOpen(true)} onMouseLeave={() => setVerwaltungOpen(false)}>
                                        <a
                                            className={`nav-link dropdown-toggle text-primary cursor-pointer ${isVerwaltungActive ? 'nav-link-active' : ''}`}
                                            onClick={() => setVerwaltungOpen(!verwaltungOpen)}
                                        >
                                            Verwaltung
                                            <PendingBillingIndicator/>
                                        </a>
                                        <ul className={`dropdown-menu dropdown-menu-glass ${verwaltungOpen ? 'show' : ''}`}>
                                            <li><Link to="/team" className="dropdown-item">Team</Link></li>
                                            {CurrentUser.data && CurrentUser.data.role === 'administrator' && (
                                                <>
                                                    <li>
                                                        <hr className="dropdown-divider"/>
                                                    </li>
                                                    <li>
                                                        <Link to="/weclapp/customers" className="dropdown-item">WeClapp-Kunden</Link>
                                                    </li>
                                                    <li>
                                                        <hr className="dropdown-divider"/>
                                                    </li>
                                                    <li>
                                                        <Link to="/invoices" className="dropdown-item d-flex justify-content-between align-items-center">
                                                            Rechnungen
                                                            <PendingBillingIndicator/>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/external-costs" className="dropdown-item">
                                                            Externe Kosten
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <hr className="dropdown-divider"/>
                                                    </li>
                                                    <li>
                                                        <Link to="/administration" className="dropdown-item">Administration</Link>
                                                    </li>
                                                </>
                                            )}
                                        </ul>
                                    </li>

                                    <li className="nav-item me-4">
                                        <NavLink
                                            to="/profile"
                                            className="nav-link text-primary"
                                            activeClassName="nav-link-active"
                                        >
                                            <i className="bi bi-person-circle me-1"></i>
                                            Profil
                                        </NavLink>
                                    </li>
                                </>
                            }
                        </ul>

                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-center">
                            {SyncInfo.loginStatus == "loggedIn" &&
                                <>
                                    {isCustomApiUrl && (
                                        <li className="nav-item me-3 d-flex align-items-center mt-2">
                                            <span className="badge rounded-pill bg-primary bg-gradient">
                                                <i className="bi bi-code-slash me-1"></i>
                                                Non-Prod
                                            </span>
                                        </li>
                                    )}
                                    <li className="nav-item">
                                        <SharkIf animate={true} show={true} animation="fade" animationDelay={500}>
                                            <div className={
                                                stylelist(
                                                    "avatar-container",
                                                    [(SyncInfo.syncStatus == "working" && SyncInfo.enableSync == true), "active"],
                                                    [(SyncInfo.syncStatus == "idle" && SyncInfo.enableSync == true), "active"],
                                                    [(SyncInfo.syncStatus == "asap" && SyncInfo.enableSync == true), "active"],
                                                    [SyncInfo.enableSync == false, "notactive"]
                                                )}>
                                                <div
                                                    onClick={() => {
                                                        dispatch(enable_sync());
                                                        dispatch(set_sync_status("asap_full"))
                                                    }}
                                                    className={stylelist([SyncInfo.syncStatus == "working", "spin-animation"], "status", "cursor-pointer", "rotate-center")}>
                                                    {(SyncInfo.syncStatus == "idle" && SyncInfo.enableSync == true) &&
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                                        </svg>
                                                    }
                                                    {(SyncInfo.syncStatus == "working" && SyncInfo.enableSync == true) &&
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-arrow-repeat" viewBox="0 0 16 16">
                                                            <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/>
                                                            <path fillRule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"/>
                                                        </svg>
                                                    }
                                                    {((SyncInfo.syncStatus == "asap" || SyncInfo.syncStatus == "asap_full") && SyncInfo.enableSync == true) &&
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-pause-circle-fill" viewBox="0 0 16 16">
                                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.25 5C5.56 5 5 5.56 5 6.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C7.5 5.56 6.94 5 6.25 5zm3.5 0c-.69 0-1.25.56-1.25 1.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C11 5.56 10.44 5 9.75 5z"/>
                                                        </svg>
                                                    }
                                                    {SyncInfo.enableSync == false &&
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-pause-circle-fill" viewBox="0 0 16 16">
                                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.25 5C5.56 5 5 5.56 5 6.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C7.5 5.56 6.94 5 6.25 5zm3.5 0c-.69 0-1.25.56-1.25 1.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C11 5.56 10.44 5 9.75 5z"/>
                                                        </svg>
                                                    }
                                                </div>
                                                <Link to="/profile">
                                                    <Gravatar className={stylelist("avatar", [SyncInfo.loginStatus == "offline", "offline"])} size={30} email={UserSettings.email}/>
                                                </Link>
                                            </div>
                                        </SharkIf>
                                    </li>
                                </>
                            }
                        </ul>
                    </div>

                    <div className="toast-wrapper">
                        <Toaster
                            position="top-center"
                            reverseOrder={false}
                            toastOptions={{
                                className: '',
                                style: {
                                    marginTop: "15px"
                                },
                            }}
                        />
                    </div>

                    <SyncComponent/>
                </nav>
            </div>

            {/* Quick Add Button - Fixed Bottom Right */}
            {CurrentUser.data && (
                <button
                    className="quick-add-fab"
                    onClick={() => setQuickAddOpen(true)}
                    title="Schnelleingabe (Strg+K)"
                >
                    <i className="bi bi-plus-lg"></i>
                </button>
            )}

            {CurrentUser.data && <QuickAddModal isOpen={quickAddOpen} onClose={() => setQuickAddOpen(false)}/>}
        </>
    );
};

export default Menu;
